import React from "react";
import Form, { FormProps } from "../form";
import { useDomainContext } from "@hooks/useDomainContext";
import { Field, FieldTypes, Step } from "@lib/shared/types";
import styles from "./styles.module.scss";
import { DomainForm } from "src/api";
// import StepsNavigation from "./steps";
// import { formatPhoneNumber, getPhoneNumber } from "@lib/sharedUtils";
// import AffiliateOfferUrl from "../affiliateOfferUrl";

const FormOfferModal = (props: FormProps) => {
    const PII_FIELDS = [
        "toZipCode",
        "zipCode",
        "streetAddress",
        "firstName",
        "lastName",
        "phoneNumber",
        "email",
    ];
    const { colors, form, stepsConfig, ignoreCategoryInThankYouPagePath } =
        props;
    const {
        form: domainContextForm,
        exitModalOffer,
        category,
        locale,
        domain,
    } = useDomainContext();

    const updateFieldType = (field: Field): FieldTypes => {
        return field.fieldType === "radio"
            ? "select"
            : field.fieldType === "checkbox"
            ? "multiSelect"
            : field.fieldType;
    };

    const getConfigTitle = (
        cfgTitle: string | { [key: string]: string } | undefined | null,
    ) => {
        if (typeof cfgTitle === "object" && cfgTitle !== null) {
            return cfgTitle?.[(locale as keyof typeof cfgTitle) || "en"] ?? "";
        }
        return cfgTitle ?? "";
    };

    const getConfigButtonText = (
        cfgButtonText: string | { [key: string]: string } | undefined | null,
    ) => {
        if (typeof cfgButtonText === "object" && cfgButtonText !== null) {
            return (
                cfgButtonText?.[
                    (locale as keyof typeof cfgButtonText) || "en"
                ] ?? "Next"
            );
        }
        return cfgButtonText ?? "Next";
    };

    // const [currentStep, setCurrentStep] = useState(0);
    const exitModalFormStepsConfig =
        domain?.config?.exitModalFormStepsConfig ||
        category?.config?.exitModalFormStepsConfig ||
        [];
    const offer = exitModalOffer?.[0];
    const _form = form ?? (domainContextForm as DomainForm);
    // const { textBlocks } = _form;
    // const phoneNumber = getPhoneNumber(offer);
    const queryParams = [];
    if (offer) {
        queryParams.push(`categoryId=${offer?.category.id.toString()}`);
        queryParams.push(`zone=exitFormModal`);
    }
    const tcpaStepIndex =
        _form?.steps.findIndex((step) => step.includeTCPAMessage) ?? -1;

    let result: DomainForm | null = null;
    if (exitModalFormStepsConfig && exitModalFormStepsConfig.length) {
        const stepNumberThatHaveZipCodeField =
            exitModalFormStepsConfig.findIndex((cfg) =>
                Array.isArray(cfg.fieldsCodeNames)
                    ? cfg.fieldsCodeNames.includes("zipCode")
                    : "zipCode" in cfg.fieldsCodeNames,
            );
        result = {
            ..._form,
            steps: [
                ...(Array.isArray(exitModalFormStepsConfig)
                    ? exitModalFormStepsConfig.map((cfg) => {
                          // Use reduce to collect fields from all steps
                          const fields: Field[] = _form.steps.reduce<Field[]>(
                              (acc, step) => {
                                  step.fields.forEach((f) => {
                                      if (
                                          Array.isArray(cfg.fieldsCodeNames)
                                              ? cfg.fieldsCodeNames.includes(
                                                    f.codeName,
                                                )
                                              : f.codeName in
                                                cfg.fieldsCodeNames
                                      ) {
                                          acc.push({
                                              ...f,
                                              label: Array.isArray(
                                                  cfg.fieldsCodeNames,
                                              )
                                                  ? f.label || step.title || ""
                                                  : cfg.fieldsCodeNames[
                                                        f.codeName
                                                    ]?.label ||
                                                    f.label ||
                                                    step.title ||
                                                    "",
                                              placeholder: Array.isArray(
                                                  cfg.fieldsCodeNames,
                                              )
                                                  ? f.placeholder ||
                                                    ([
                                                        "select",
                                                        "radio",
                                                        "multiSelect",
                                                        "checkbox",
                                                    ].includes(f.fieldType)
                                                        ? "Select option"
                                                        : "")
                                                  : cfg.fieldsCodeNames[
                                                        f.codeName
                                                    ]?.placeholder,
                                              fieldType: updateFieldType(f),
                                          });
                                      }
                                  });
                                  return acc;
                              },
                              [],
                          );
                          const stepTitle = getConfigTitle(cfg?.title);

                          return {
                              title: stepTitle,
                              includeTCPAMessage:
                                  cfg.includeTCPAMessage ?? false,
                              TCPAMessage:
                                  cfg.includeTCPAMessage && tcpaStepIndex >= 0
                                      ? _form.steps[tcpaStepIndex]
                                            ?.TCPAMessage ?? null
                                      : null,
                              buttonText: getConfigButtonText(cfg?.buttonText),
                              fields,
                              description: "",
                              id: 1,
                              tooltip: "",
                          };
                      })
                    : []),
            ],
            stepToSendingData: 0,
            ...(stepNumberThatHaveZipCodeField > -1
                ? { stepToFetchBuyers: stepNumberThatHaveZipCodeField }
                : {}), // add dynamically
        };
    } else {
        result = {
            ..._form,
            steps: [
                {
                    ..._form?.steps[0],
                    fields: [] as Field[],
                },
                {
                    ..._form?.steps.find((step) =>
                        step.fields.find((field) =>
                            PII_FIELDS.includes(field.codeName),
                        ),
                    ),
                    includeTCPAMessage: true,
                    TCPAMessage:
                        _form.steps[tcpaStepIndex]?.TCPAMessage ?? null,
                    buttonText: _form.steps[_form.steps.length - 1].buttonText,
                    description: "",
                    fields: [] as Field[],
                    id: 2,
                    tooltip: "",
                } as Step,
            ],
            stepToSendingData: 0,
        };
        _form?.steps.forEach((step) => {
            step.fields.forEach((field) => {
                if (PII_FIELDS.includes(field.codeName)) {
                    result?.steps[1].fields.push({
                        ...field,
                        fieldType: updateFieldType(field),
                    });
                } else {
                    result?.steps[0].fields.push({
                        ...field,
                        label: field.label || step.title || "",
                        fieldType: updateFieldType(field),
                        placeholder:
                            field.placeholder ||
                            ([
                                "select",
                                "radio",
                                "multiSelect",
                                "checkbox",
                            ].includes(field.fieldType)
                                ? "Select option"
                                : ""),
                    });
                }
            });
        });
    }

    if (!result) {
        return null;
    }
    // const stepsCount = result.steps.length;

    // const result = {
    //     ..._form,
    //     steps: [
    //         {
    //             ..._form?.steps[0],
    //             fields: [] as Field[],
    //         },
    //         {
    //             ..._form?.steps.find((step) =>
    //                 step.fields.find((field) =>
    //                     PII_FIELDS.includes(field.codeName),
    //                 ),
    //             ),
    //             includeTCPAMessage: true,
    //             TCPAMessage: _form.steps[tcpaStep].TCPAMessage,
    //             buttonText: _form.steps[_form.steps.length - 1].buttonText,

    //             fields: [] as Field[],
    //         },
    //     ],
    //     stepToSendingData: 0,
    // };
    // const marketingMessage = textBlocks?.find(
    //     (item) => item.position === "form-inside-modal-marketing-message",
    // );

    // _form?.steps.forEach((step) => {
    //     step.fields.forEach((field) => {
    //         if (PII_FIELDS.includes(field.codeName)) {
    //             result.steps[1].fields.push({
    //                 ...field,
    //                 fieldType: updateFieldType(field),
    //             });
    //         } else {
    //             result.steps[0].fields.push({
    //                 ...field,
    //                 label: field.label || step.title || "",
    //                 fieldType: updateFieldType(field),
    //                 placeholder:
    //                     field.placeholder ||
    //                     ([
    //                         "select",
    //                         "radio",
    //                         "multiSelect",
    //                         "checkbox",
    //                     ].includes(field.fieldType)
    //                         ? "Select option"
    //                         : ""),
    //             });
    //         }
    //     });
    // });

    return (
        <div className="flex flex-col sm:flex-row">
            {/* {offer && (
                <div className="w-full flex flex-col items-center justify-between">
                    <div className="flex flex-col items-center justify-center gap-2 sm:gap-4 mb-6 px-3 flex-1 h-full">
                        <div className="max-w-[300px]">
                            <a
                                href={`/offer/${
                                    offer?.slug ?? ""
                                }?${queryParams.join("&")}`}
                            >
                                <img
                                    src={offer?.logo?.fullPath}
                                    alt="endurance offer 300 off"
                                    className="w-full"
                                />
                            </a>
                        </div>
                        {marketingMessage && (
                            <a
                                href={`/offer/${
                                    offer?.slug ?? ""
                                }?${queryParams.join("&")}`}
                            >
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: marketingMessage?.text,
                                    }}
                                />
                            </a>
                        )}
                        <AffiliateOfferUrl
                            zone={"exitFormModal"}
                            className="bg-[#FF8800] px-8 py-2 flex items-center gap-4 font-bold text-xl rounded-[4px] shadow-lg hover:shadow transition-all duration-200 ease-in-out hover:opacity-[0.8]"
                            offer={offer}
                            target="_blank"
                            customHref={
                                phoneNumber
                                    ? `tel:${phoneNumber ?? ""}`
                                    : undefined
                            }
                        >
                            {formatPhoneNumber(phoneNumber) ?? "Get a Quote"}
                        </AffiliateOfferUrl>
                        {phoneNumber && (
                            <AffiliateOfferUrl
                                zone={"exitFormModal"}
                                offer={offer}
                                target="_blank"
                                className="text-[#31AAFC] inline-block border-b border-b-[#31AAFC]"
                            >
                                <span>Get a Quote</span>
                            </AffiliateOfferUrl>
                        )}
                    </div>
                    <img
                        src="https://cdn-staging.trafficbox.com/attachments/2024/7/d352c297-3596-4526-a858-316af1d32454.jpg"
                        alt="endurance offer 300 off"
                    />
                </div>
            )} */}
            <div className="w-full bg-[#f8f8f8] relative max-w-[500px]">
                {/* <StepsNavigation
                    stepsCount={stepsCount}
                    currentStep={currentStep}
                /> */}
                <Form
                    classes={{
                        formClassName: styles["form"],
                        stepClassName: styles["step"],
                        fieldsClassName: {
                            radio: styles["radio-field"],
                            multiSelect: styles["multi-select-field"],
                        },
                        formButtonClassName: styles["form-button"],
                        formFieldLabelClassName: styles["field-label"],
                        stepTitleClassName: styles["step-title"],
                        fieldNoteClassName: styles["field-note"],
                        formFieldClassName: styles["form-field"],
                        stepDescriptionClassName: styles["step-description"],
                        sellingPointClassName: styles["selling-point"],
                        formStepInnerClassName: styles["steps-inner"],
                        tcpaClassName: styles["tcpa"],
                    }}
                    backButton={props?.backButton}
                    showProgress={false}
                    colors={{
                        ...colors,
                        primaryColor:
                            colors.primaryColor ||
                            "var(--global-headerAndFooter-modals-button-background-color, #eb7f58)",
                    }}
                    form={result}
                    dynamicThankYouFields={[
                        "firstName",
                        "manufacturingYear",
                        "vehicleMake",
                        "vehicleModel",
                    ]}
                    isFormInsideOffersModal
                    // Follow the page form's thank-you behavior instead of
                    // always redirecting. On inline (non-redirect) domains this
                    // lets the page form show its inline thank-you after the
                    // exit-modal submit, rather than navigating to /thank-you.
                    goToThankYouPage={props.goToThankYouPage ?? false}
                    ignoreCategoryInThankYouPagePath={
                        ignoreCategoryInThankYouPagePath
                    }
                    stepsConfig={stepsConfig}
                    onInlineThankYouShown={props.onInlineThankYouShown}
                    // setCurrentStep={setCurrentStep}
                />
            </div>
        </div>
    );
};

export default FormOfferModal;
